'use client';

import { LoadingAnimation } from './component';
import { hide, show } from './imperative';

export type { ILoadingAnimationProps } from './component';
export type { ILoadingShowOptions } from './imperative';
export { hide, show };

type TLoadingAnimation = typeof LoadingAnimation & {
    show: typeof show;
    hide: typeof hide;
};

const LoadingAnimationWithImperative = LoadingAnimation as TLoadingAnimation;
LoadingAnimationWithImperative.show = show;
LoadingAnimationWithImperative.hide = hide;

export default LoadingAnimationWithImperative;
